import React, { useEffect } from "react";
import ItemDetailPanelView from "presentational/itemDetail/ItemDetailPanelView";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";
import PropTypes from "prop-types";

RootItemDetail.propTypes = {
  itemHash: PropTypes.string.isRequired
};

function RootItemDetail(props) {
  const {
    itemHash,
    itemInfo,
    memoData,
    outfitList,
    isEnd,
    isLoading,
    ItemDetailActions,
    MyItemActions,
    OutfitDetailActions,
    AppErrorActions
  } = props;
  const { getIdTokenWT } = props;

  useEffect(() => {
    requestItemAndOutfitData();
  }, []);

  const requestItemAndOutfitData = async () => {
    try {
      const { idToken, hasTokenExpired } = await getIdTokenWT();
      if (hasTokenExpired) return null;

      ItemDetailActions.initOutfitListAndItemInfo({
        itemHash,
        idToken
      });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const getNextList = async () => {
    try {
      const { idToken, hasTokenExpired } = await getIdTokenWT();
      if (hasTokenExpired) return null;

      ItemDetailActions.requestNextList({
        idToken
      });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const writeMemoToBackend = async ({
    nickname,
    place,
    sizeDetail,
    memo,
    hasNicknameChanged
  }) => {
    try {
      const { idToken, hasTokenExpired } = await getIdTokenWT();
      if (hasTokenExpired) return null;

      ItemDetailActions.writeMemoData({
        itemHash: itemInfo.itemHash,
        memoObj: { nickname, place, sizeDetail, memo },
        idToken
      });

      if (hasNicknameChanged) {
        MyItemActions.updateNicknameFromItem({ itemHash, nickname });
        OutfitDetailActions.updateNicknameFromItem({ itemHash, nickname });
      }
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  return (
    <ItemDetailPanelView
      itemInfo={itemInfo}
      memoData={memoData}
      outfitList={outfitList}
      isLoading={isLoading}
      isEnd={isEnd}
      getNextList={getNextList}
      onMemoSubmitClick={writeMemoToBackend}
    />
  );
}

export default withStore({
  stateMap: {
    itemDetail: ["itemInfo", "memoData", "outfitList", "isEnd", "isLoading"]
  },
  dispatchMap: ["itemDetail", "myItem","outfitDetail", "appError"]
})(withToken(RootItemDetail));
